<template>
	<div class="routelist">
		<div v-show="routes.length === 0" class="routelist__empty">Fant ingen turer</div>
		<div class="routelist__item" v-for="route in routes" @mouseover="routeMouseover(route)" @mouseout="routeMouseout(route)" @click="routeClick(route)" :key="route.page_id">
			<div class="routelist__image" :class="{ 'routelist__image--inactive': route.opening_date }">
				<img v-if="route.thumb" :src="route.thumb">
				<div class="routelist__placeholder" v-if="route.t == 0"></div>
			</div>
			<div class="routelist__description" :class="{ 'routelist__description--registered': registrations[route.page_id] }">
				<div class="routelist__topinfo" :class="{ 'routelist__topinfo--inactive': route.opening_date }">
					<h3 class="routelist__title" :class="{ 'routelist__title--long': (route.name.length > 40) }" v-html="route.name"></h3>
					<div class="routelist__county">{{ route.countyName }}</div>
				</div>
				<div class="routelist__facts" :class="{ 'routelist__facts--inactive': route.opening_date }">
					<div v-if="!route.opening_date">
						<span class="routelist__grade" :class="'routelist__grade--' + route.grade + ' routelist__grade__' + route.type + '--' + route.grade">{{ grades[route.grade] }}</span>
						<span v-show="route.length" class="routelist__fact routelist__fact--length">
							{{ route.length }}
						</span>
						<span v-show="route.maptrack" class="routelist__fact routelist__fact--elevation">
							<svg class="routelist__fact-icon" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><polygon points="8,1 15,13 1,13" fill="currentColor"/></svg>
							{{ route.elevation }} hm
						</span>
						<img class="routelist__hc" v-if="route.hc > 0" src="/img/rullestolvennlig.svg" alt="Rullestolvennlig" title="Rullestolvennlig">
					</div>
					<div v-else>
						<b>Forventet åpningsdag {{route.opening_date}}</b>
					</div>
				</div>
				<button
					type="button"
					class="routelist__heart" :class="{ 'routelist__heart--selected': favourites[route.page_id] }"
					title="Lagre på min side"
					@click.stop="toggleFavourite(route)"
					v-if="currentUser != false"
				></button>
				<span v-if="registrations[route.page_id]" class="routelist__registered"></span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				grades: [
					'Enkel',
					'Middels',
					'Krevende',
					'Ekspert'
				],
				types: [
					'Enkel',
					'Middels',
					'Krevende',
					'Ekspert'
				]
			}
		},
		props: {
			config: Object,
			favourites: Object,
			registrations: Object,
			routes: { type: Array, default: () => [] },
			// Explicit prop (rather than reading window.mapConfig directly) so
			// this component is reusable outside /turer - the /min-side
			// "Favoritter" tab (app/js/stikkut/FavouriteList.vue) feeds it too.
			currentUser: { type: [Number, Boolean], default: false }
		},
		emits: ['mouseover', 'mouseout', 'toggle-favourite'],
		components: {

		},
		watch: {
			routes(routes) {
				routes.forEach((route) => {
					route.currentImage = 1;
				});
			}
		},
		methods: {
			routeMouseover(route) {
				this.$emit('mouseover', route);
			},
			routeMouseout(route) {
				this.$emit('mouseout', route);
			},
			routeClick(route) {
				location.href = route.url;
			},
			nextThumb(route) {
				if (route.currentImage < route.t) {
					route.currentImage++;
				}
				else {
					route.currentImage = 1;
				}
			},
			prevThumb(route) {
				if (route.currentImage > 1) {
					route.currentImage--;
				}
				else {
					route.currentImage = route.t;
				}
			},
			// The actual POST (and the CSRF token it needs) lives in whichever
			// root app renders this list - Routemap.vue for /turer,
			// FavouriteList.vue for the /min-side "Favoritter" tab - so this
			// component stays a plain, reusable list with no network/CSRF
			// concerns of its own. The heart's filled state comes from the
			// favourites prop, which that root updates once the toggle lands.
			toggleFavourite(route) {
				this.$emit('toggle-favourite', route);
			}
		}
	}
</script>

<style>

</style>